import React, { useState } from "react";
import { Service } from "utils/services";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTachometerAlt,
  faUsersCog,
  faBoxOpen,
  faBullhorn,
  faUserPlus,
  faHandHoldingUsd,
  faBriefcase,
  faCalendarAlt,
  faChevronUp,
  faChevronDown,
  faTasks,
  faMusic,
  faScrewdriverWrench,
} from "@fortawesome/free-solid-svg-icons";
import ImageUrlProfile from "../image-url/ImageUrlProfile";
import { RouteUrl, StatusMsg } from "utils";

import { AppLog } from "services";
import { useNavigate } from "react-router-dom";
import { ShimmerNewFeedLeftSideBirthday, ShimmerNewFeedLeftSideConnector } from "../shrimmer/Shrimmer";
import { useDispatch } from "react-redux";
import { setIsDialogCreateShopOpen } from "store/header";
import { profileVerified } from "assets";
import ImageUrlProfileStory from "../image-url/ImageUrlProfileStory";

const menuItems = [
  {
    name: "Dashboard",
    url: RouteUrl.accountDashboard,
    icon: <FontAwesomeIcon icon={faTachometerAlt} className="bg-cyan-500" />,
  },

  ...(Service?.userAuth?.user_type === "Personal"
    ? [
        {
          name: "Staffs",
          url: RouteUrl.staff,
          icon: <FontAwesomeIcon icon={faUsersCog} className="bg-yellow-500" />,
        },
      ]
    : []),

  {
    name: "Music Libraries",
    url: RouteUrl.musicLibraries,
    icon: <FontAwesomeIcon icon={faMusic} className="bg-lime-500" />,
  },

  ...(Service?.userAuth?.user_type === "Personal"
    ? [
        {
          name: "Products & Services",
          url: RouteUrl.productService,
          icon: <FontAwesomeIcon icon={faBoxOpen} className="bg-purple-500" />,
        },
      ]
    : []),

  {
    name: "Campaigns",
    url: RouteUrl.campaigns,
    icon: <FontAwesomeIcon icon={faBullhorn} className="bg-green-500" />,
  },
  {
    name: "Leads",
    url: RouteUrl.leads,
    icon: <FontAwesomeIcon icon={faUserPlus} className="bg-red-500" />,
  },
  {
    name: "Opportunities",
    url: RouteUrl.opportunities,
    icon: <FontAwesomeIcon icon={faHandHoldingUsd} className="bg-blue-600" />,
  },
  {
    name: "Jobs",
    url: RouteUrl.jobs,
    icon: <FontAwesomeIcon icon={faBriefcase} className="bg-gray-700" />,
  },
  {
    name: "Events",
    url: RouteUrl.events,
    icon: <FontAwesomeIcon icon={faCalendarAlt} className="bg-teal-500" />,
  },
  {
    name: "Projects",
    url: RouteUrl.projects,
    icon: <FontAwesomeIcon icon={faTasks} className="bg-purple-600" />,
  },
  {
    name: "Tools",
    url: RouteUrl.toolsAccount,
    icon: <FontAwesomeIcon icon={faScrewdriverWrench} className="bg-purple-600" />,
  },
];

type NewFeedLeftSideBarState = {
  connectorUsers: any[];
  connectorUsersLoading: boolean;
  birthdayUsers: any[];
  birthdayUsersLoading: boolean;
  lastActiveShopId: string;
};

const NewFeedLeftSidebar: React.FC<NewFeedLeftSideBarState> = ({ connectorUsers, connectorUsersLoading, birthdayUsers, birthdayUsersLoading, lastActiveShopId }) => {
  const dispatch = useDispatch();
  const [showMore, setShowMore] = useState(false);
  const [hovered, setHovered] = useState(false);
  const navigate = useNavigate();
  const itemsToShow = showMore ? menuItems : menuItems.slice(0, 6);

  const localUserString = localStorage.getItem("user");
  const localUser = localUserString ? JSON.parse(localUserString) : null;
  const localLastActiveShopId = localUser.last_active_shop_id;

  const _onClickedMenu = (item: any) => {
    try {
      if (localLastActiveShopId !== "_create_new" && localLastActiveShopId) {
        if (item.url) {
          if (["/account-dashboard"].includes(item.url)) {
            navigate(`${item.url}?id=${Service.userAuth.account_id}`);
          } else {
            navigate(`${item.url}?id=${localLastActiveShopId}`);
          }
        }
      } else {
        if (["/staff", "/product-service"].includes(item.url)) {
          dispatch(setIsDialogCreateShopOpen(true));
        } else {
          navigate(`${item.url}?id=${Service.userAuth.account_id}`);
        }
      }
    } catch (error) {
      AppLog.show({
        message: `[_onClickedMenu]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  return (
    <div className="pt-4 h-full flex flex-col">
      {/* Scrollable Content */}
      <div
        className={`flex-1 overflow-y-auto space-y-4 ${hovered ? "scrollbar-visible" : "scrollbar-custom"}`}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        {/* Profile Section */}
        <div className="flex items-center space-x-3 px-2 rounded-md cursor-pointer ">
          <ImageUrlProfile user={Service.userAuth} style={{ width: 40, height: 40 }} className="rounded-full object-cover border shadow-md " isLinkProfile={true} />
          <div>
            <span className="text-base font-bold line-clamp-1">
              {Service.userAuth?.name}
              {Service.userAuth?.shop_name}
            </span>

            <span className="text-base text-muted-foreground line-clamp-1">
              {Service.userAuth?.bio}
              {Service.userAuth?.description}
            </span>
          </div>
        </div>
        {/* Menu Items */}
        <div className="space-y-1">
          {itemsToShow.map((item, index) => (
            <div
              key={index}
              className="flex items-center space-x-3 p-2 rounded-md cursor-pointer hover:bg-accent hover:text-accent-foreground"
              onClick={() => _onClickedMenu(item)}
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-full ${item.icon.props.className.replace("text-", "bg-")}`}>
                {React.cloneElement(item.icon, { className: "text-white" })}
              </div>
              <span className="text-sm font-medium ">{item.name}</span>
            </div>
          ))}

          {/* See More / See Less Button */}
          {menuItems.length > 6 && (
            <div onClick={() => setShowMore(!showMore)} className="flex items-center space-x-3  p-2 rounded-md cursor-pointer hover:bg-accent hover:text-accent-foreground">
              <div className="w-8 h-8 bg-gray-300 flex items-center justify-center rounded-full">
                <FontAwesomeIcon icon={showMore ? faChevronUp : faChevronDown} className="text-gray-600" />
              </div>
              <span className="text-sm font-medium ">{showMore ? "See less" : "See more"}</span>
            </div>
          )}
        </div>

        {/* Divider */}
        <div className="border-t border-gray-300 my-4"></div>

        {/* Birthdays Section */}
        <div>
          <h4 className="text-sm font-semibold  mb-2">Birthdays</h4>
          {birthdayUsersLoading ? (
            <ShimmerNewFeedLeftSideBirthday />
          ) : birthdayUsers.length === 0 ? (
            <p className="text-sm ">
              <span className="text-xs text-muted-foreground">You have no friends' birthdays.</span>
            </p>
          ) : (
            <p className="text-sm ">
              <span className="font-semibold">{birthdayUsers[0].name}</span> and
              <span className="font-light">{` ${birthdayUsers.length - 1}`} others have birthdays today.</span>
            </p>
          )}
        </div>
        {/* Divider */}
        <div className="border-t border-gray-300"></div>

        {/* Connector */}
        <div>
          <h4 className="text-sm font-semibold mb-2">Connector</h4>

          {connectorUsersLoading ? (
            <ShimmerNewFeedLeftSideConnector />
          ) : (
            <div className="">
              {connectorUsers.map((user, index) => (
                <div key={user.id} className="flex flex-row space-x-2 w-full items-center">
                  <ImageUrlProfileStory user={user} className="w-14 h-14 shrink-0" isLinkProfile={true} />

                  <div className="flex w-full max-w-full flex-row justify-between items-center">
                    <div className="flex flex-col max-w-full w-full">
                      <div className="flex items-center space-x-2 max-w-full">
                        <p className="text-sm font-medium line-clamp-2 overflow-hidden">{user.name}</p>

                        {user.is_verified === "Yes" && <img src={profileVerified} alt="" className="w-[15px] h-[15px]" />}
                      </div>

                      <div className="flex items-center space-x-2 max-w-full">
                        <p className="text-xs text-muted-foreground line-clamp-2 overflow-hidden">
                          {`${user.no_of_follower ? `${user.no_of_follower} Followers` : ""}
                                                    ${user.no_of_like ? `• ${user.no_of_like} Likes` : ""}
                                                `}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NewFeedLeftSidebar;

